import React, { ReactNode } from 'react'
import './Grid.scss'

interface GridProps {
  children: ReactNode
}

function Grid(props: GridProps) {
  const { children } = props
  const getResponsiveClass = (
    start: number,
    col: number,
    align: string,
    order: string
  ) => `start-${start} col-${col} align-${align} order-${order}`

  return (
    <div className="grid-wrapper">
      <div className="grid-container">
        {React.Children.map(children, child => {
          const element = child as React.ReactElement

          const isHidden = element.props.className?.match(/grid-hidden/)
          if (isHidden) return null

          const start = parseInt(
            element.props.className?.match(/start-(\d+)/)?.[1] || '1',
            10
          )

          const col = parseInt(
            element.props.className?.match(/col-(\d+)/)?.[1] || '1',
            10
          )

          const align =
            element.props.className?.match(/align-(\w+)/)?.[1] || 'center'

          const order =
            element.props.className?.match(/order-(\w+)/)?.[1] || 'center'

          const responsiveClass = getResponsiveClass(start, col, align, order)

          return (
            <div className={`grid__item ${responsiveClass}`}>{element}</div>
          )
        })}
      </div>
    </div>
  )
}

export default Grid
